import React, { useEffect, useState } from 'react';
import Modal from '../../../common/components/Modal/modal';
import { Formik, Form, useFormik } from 'formik';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CloseIcon from '@material-ui/icons/Close';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import {
  getLoanProduct,
  getPhoneNumberExist,
  addOrEditLead,
  GetAllRmList
} from '../../../common/constants/api';
import CircularProgress from '@material-ui/core/CircularProgress';
import { object, string, number } from 'yup';
import * as _ from 'lodash';
import PopUp from '../../../common/components/PopUp/PopUp';
import { getAcl } from '../../../common/utils/acl-utils';
import Toast from '../../../common/components/Toast/Toast';

const AddLeadsRmSide = ({
  showModal,
  setShowModal,
  setAddLead,
  onAddLeadAdded
}) => {
  const [showOtherCityField, setShowOtherCityField] = useState(false);
  const [userType, setUserType] = useState(
    getAcl()?.acl?.can_assign_rm ? true : false
  );
  const [loanProductLoading, setLoanProductsLoading] = useState(true);
  const [loanProduct, setLoanProduct] = useState([]);
  const [mobileCheckinhgLoader, setMobileCheckinhgLoader] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [loadingRMList, setLoadingRMList] = useState(false);
  const [rmList, setRmList] = useState([]);

  const validationSchema = object().shape({
    first_name: string().required('Required'),
    mob: string()
      .required('Required')
      .length(10, 'should be 10 digit!')
      .when('isMobExcist', {
        is: true,
        then: string().test('name', 'Mobile number already exist!', () => false)
      }),
    email: string()
      .notRequired()
      .email('Not a valid email'),
    assign_toRm: object().when('userType', {
      is: val => val == true,
      then: object().shape({
        value: string('').required('Required')
      })
    })
  });

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      mob: '',
      isMobExcist: false,
      city: {
        value: '',
        label: 'City'
      },
      source: {
        value: '',
        label: 'Source'
      },
      sub_source: {
        value: '',
        label: 'Sub Source'
      },
      typeOf_loan: {
        value: '',
        label: 'Type Of Loan'
      },
      onLoading: true,
      assign_toRm: {
        value: '',
        label: (
          <span>
            Assign To RM<span className="text-red-100">*</span>
          </span>
        )
      },
      userType: userType
    },
    validationSchema: validationSchema,
    onSubmit: values => {}
  });

  const commonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      onBlur: formik.handleBlur,
      value: formik.values[name],
      error: formik.touched[name] && formik.errors[name],
      errorMsg: formik.errors[name],
      touched: formik.touched[name],
      setFieldValue: formik.setFieldValue,
      stylesContainer: { maxWidth: '100%' }
    };
  };

  const modalStyle = {
    maxWidth: '600px',
    minWidth: '250px'
  };

  const commonInputDiv = 'md:w-6/12 w-full px-3 py-1 my-2';

  const mobFiledStyle = {
    stylesContainer: { maxWidth: '100%' },

    inputStyle: {
      paddingLeft: '40px',
      letterSpacing: '1px'
    },
    onBlurStyle: {
      paddingLeft: '20px'
    },
    legendStyle: {
      paddingLeft: '20px'
    },
    className: `pt-24`
  };
  const otherCityStyle = {
    stylesContainer: { maxWidth: '100%' },

    inputStyle: {
      paddingLeft: '85px',
      letterSpacing: '1px'
    },
    onBlurStyle: {
      paddingLeft: '85px'
    },
    legendStyle: {
      paddingLeft: '20px'
    },
    className: `pt-24`
  };

  const selectBoxCommonStyle = isDisabled => {
    return {
      dropdownStyle: {
        top: '52px',
        fontSize: '16px'
      },
      stylesContainer: {
        height: '52px',
        ...(isDisabled ? { opacity: '0.5' } : {})
      },
      styleText: {
        fontSize: '14px',
        padding: '0 20px'
      }
    };
  };

  const cityOnChange = e => {
    formik.setFieldValue('city', {
      value: e.value,
      label: e.label
    });
    if (e.value != 'Others') return;
    setShowOtherCityField(true);
  };

  const selectFiledCommonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      error:
        formik.touched[name] && _.get(formik.errors, `${name}.value`, false),
      touched: formik.touched[name],
      value: formik.values[name]
    };
  };
  const handleMobileNumber = e => {
    if (isNaN(e.target.value) || e.target.value.toString().length > 10) return;
    formik.setFieldValue('mob', e.target.value);
    setMobileCheckinhgLoader(false);
  };

  const handleFirstName = e => {
    let patt = new RegExp(/[^a-z,^A-Z,\s]/g);
    let errors = e.target.value.toString().match(patt);
    if (errors) return;
    formik.setFieldValue('first_name', e.target.value);
  };

  const handleLastName = e => {
    let patt = new RegExp(/[^a-z,^A-Z,\s]/g);
    let errors = e.target.value.toString().match(patt);
    if (errors) return;
    formik.setFieldValue('last_name', e.target.value);
  };

  const cityOptions = [
    {
      value: 'Bangalore',
      label: 'Bangalore'
    },
    {
      value: 'Delhi',
      label: 'Delhi'
    },
    {
      value: 'Mumbai',
      label: 'Mumbai'
    },
    {
      value: 'Pune',
      label: 'Pune'
    },
    {
      value: 'Others',
      label: 'Others'
    }
  ];

  const sourceOptions = [
    {
      value: 'Business-To-Consumer',
      label: 'B2C'
    },
    {
      value: 'RM',
      label: 'Direct'
    },
    {
      value: 'SmartAsset',
      label: 'Smart Asset'
    }
  ];

  const subSource = [
    {
      value: 'B2C-Facebook',
      label: 'Facebook'
    },
    {
      value: 'B2C-Google',
      label: 'Google'
    },
    {
      value: 'B2C-Website',
      label: 'Website'
    },
    {
      value: 'B2C-Mobile',
      label: 'Mobile'
    },
    {
      value: 'B2C-Affiliate',
      label: 'Affiliate'
    },
    {
      value: 'B2C-Partner',
      label: 'Partner'
    }
  ];

  const sourceOnChnage = e => {
    formik.setFieldValue('source', {
      value: e.value,
      label: e.label
    });
  };

  const typeOfLoanChange = e => {
    formik.setFieldValue('typeOf_loan', {
      value: e.value,
      label: e.label
    });
  };

  const subSourceChange = e => {
    formik.setFieldValue('sub_source', {
      value: e.value,
      label: e.label
    });
  };

  useEffect(() => {
    setLoanProductsLoading(true);
    getLoanProduct()
      .then(res => {
        setLoanProductsLoading(false);
        if (res.error) return;
        let loanProduct = [];
        res.forEach(element => {
          loanProduct.push({
            value: element.id,
            label: element.displayName
          });
        });
        setLoanProduct(loanProduct);
        setLoanProductsLoading(false);
      })

      .catch(error => {
        setLoanProductsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!formik.values?.mob || formik?.values?.mob?.length != 10) return;
    setMobileCheckinhgLoader(true);
    getPhoneNumberExist(formik.values?.mob)
      .then(res => {
        setMobileCheckinhgLoader(false);
        if (res.error) return;
        if (res) {
          formik.setFieldValue('isMobExcist', true);
        } else {
          formik.setFieldValue('isMobExcist', false);
        }
      })
      .catch(error => {
        setMobileCheckinhgLoader(false);
      });
  }, [formik.values.mob]);

  const handleSubmition = () => {
    formik.validateForm().then(res => {
      if (Object.keys(res).length != 0) {
        formik.handleSubmit();
      } else {
        createLead();
      }
    });
  };

  const createLead = () => {
    setAddLead(true);
    setShowModal(false);
    setShow(true);
    setType('loading');
    setText('Creating lead please wait...');

    let body = {
      name: {
        firstName: formik.values.first_name,
        lastName: formik.values.last_name || ''
      },
      ...(formik.values.email ? { email: formik.values.email } : ''),
      phone: formik.values.mob,
      productId: formik.values.typeOf_loan.value,
      leadStatus: 'OPEN',
      subStatus: 'FRESH',
      loanAmount: formik.values.loan_amount,
      city:
        formik.values?.city?.value == 'Others'
          ? formik.values.otherCity
          : formik.values?.city?.value,
      sourceName:
        (formik.values.source.value == 'Business-To-Consumer'
          ? formik.values.sub_source.value
          : formik.values.source.value) || 'RM',
      ...(userType ? { leadOwnerId: formik.values.assign_toRm.value } : {})
    };
    addOrEditLead(body)
      .then(res => {
        if (res.error) throw new Error(res);
        setShow(false);
        setAddLead(false);
        Toast(
          'success',
          'Lead has been added successfully',
          '3000',
          'top-center'
        );

        if (typeof onAddLeadAdded == 'function') onAddLeadAdded();
      })
      .catch(error => {
        setShow(false);
        setAddLead(false);
      });
  };

  useEffect(() => {
    setLoadingRMList(true);
    GetAllRmList()
      .then(res => {
        if (res.error) throw new Error(res);
        let rm_list = [];
        res.map(each => {
          rm_list.push({
            value: each.userId,
            label: each.fullName
          });
        });
        setRmList(rm_list);
        setLoadingRMList(false);
      })
      .catch(error => {
        setLoadingRMList(false);
      });
  }, []);

  const handleRmChange = e => {
    formik.setFieldValue('assign_toRm', {
      value: e.value,
      label: e.label
    });
  };

  return (
    <form>
      <div className="w-full">
        <Modal
          show={showModal}
          setShow={setShowModal}
          title={
            <span className="font-bold font-roboto text-xl text-black-0">
              Add New Lead
            </span>
          }
          styleContainer={modalStyle}
        >
          <hr
            className="border-grey-100 w-full"
            style={{ borderWidth: 'thin' }}
          />
          <div
            className="w-full overflow-auto"
            style={{ maxHeight: '80vh', overflow: 'auto' }}
          >
            <div className="md:flex  mt-5 ">
              <div className={`${commonInputDiv} `}>
                <CommonInput
                  legendName="First Name"
                  {...commonFormikFunction('first_name')}
                  onChange={handleFirstName}
                />
              </div>
              <div className={`${commonInputDiv}`}>
                <CommonInput
                  legendName="Last Name"
                  {...commonFormikFunction('last_name')}
                  onChange={handleLastName}
                />
              </div>
            </div>
            <div className="md:flex ">
              <div className={`${commonInputDiv}`}>
                <CommonInput
                  legendName="Email ID"
                  {...commonFormikFunction('email')}
                  onChange={formik.handleChange}
                />
              </div>
              <div className={`mobile_field ${commonInputDiv}`}>
                <div className="grid_input_container relative flex">
                  <div
                    style={{ marginTop: '17px' }}
                    className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                  >
                    +91
                  </div>
                  <div className="w-full">
                    <CommonInput
                      maxLength={10}
                      {...commonFormikFunction('mob')}
                      {...mobFiledStyle}
                      onChange={handleMobileNumber}
                      legendName={
                        <span>
                          Mobile No.<span className="text-red-100">*</span>
                        </span>
                      }
                    />
                  </div>
                  {mobileCheckinhgLoader ? (
                    <div className="relative text-grey-50 z-10 font-normal text-sm pt-px text-md -ml-16 mt-4 w-2">
                      <CircularProgress
                        style={{ width: '25px', height: '25px' }}
                        className="text-teal"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="md:flex ">
              {showOtherCityField ? (
                <div className={`mobile_field ${commonInputDiv}`}>
                  <div className="grid_input_container relative flex">
                    <div
                      style={{ marginTop: '17px' }}
                      className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                    >
                      Other City-
                    </div>
                    <div className="w-full">
                      <CommonInput
                        {...commonFormikFunction('otherCity')}
                        {...otherCityStyle}
                      />
                    </div>
                    <div
                      className="relative text-grey-50 z-10 font-normal text-sm pt-px text-md -ml-10 mt-4"
                      onClick={() => setShowOtherCityField(false)}
                    >
                      <CloseIcon />
                    </div>
                  </div>
                </div>
              ) : (
                <div className={`${commonInputDiv}`}>
                  <CommonSelect 
                    onChange={cityOnChange}
                    options={cityOptions}
                    {...selectBoxCommonStyle(false)}
                    {...selectFiledCommonFormikFunction('city')}
                  />
                </div>
              )}
            </div>

            <div className="md:flex ">
              <div className={`${commonInputDiv}`}>
                <CommonSelect sort={true}
                  onChange={sourceOnChnage}
                  options={sourceOptions}
                  {...selectBoxCommonStyle(false)}
                  {...selectFiledCommonFormikFunction('source')}
                />
              </div>
              <div className={`${commonInputDiv}`}>
                <CommonSelect sort={true}
                  onChange={subSourceChange}
                  options={subSource}
                  {...selectBoxCommonStyle(
                    formik.values.source.value == 'Business-To-Consumer'
                      ? false
                      : true
                  )}
                  {...selectFiledCommonFormikFunction('sub_source')}
                  disabled={
                    formik.values.source.value == 'Business-To-Consumer'
                      ? false
                      : true
                  }
                />
              </div>
            </div>

            <div className="md:flex ">
              <div className={`${commonInputDiv} flex`}>
                <CommonSelect sort={true}
                  onChange={typeOfLoanChange}
                  options={loanProduct}
                  {...selectBoxCommonStyle(false)}
                  {...selectFiledCommonFormikFunction('typeOf_loan')}
                  dropdownStyle={{
                    top: '-150px',
                    fontSize: '16px'
                  }}
                />
                {loanProductLoading ? (
                  <div className="relative text-grey-50 z-10 font-normal text-sm pt-px text-md -ml-16 mt-4 w-2">
                    <CircularProgress
                      style={{ width: '25px', height: '25px' }}
                      className="text-teal"
                    />
                  </div>
                ) : null}
              </div>
              <div className={`${commonInputDiv}`}>
                <InputTypeNumber
                  legendName="Loan Amount"
                  {...commonFormikFunction('loan_amount')}
                  maxLength={10}
                  minLength={0}
                  showInText={false}
                />
              </div>
            </div>
            {userType ? (
              <div className={`${commonInputDiv} flex`}>
                <CommonSelect sort={true}
                  onChange={handleRmChange}
                  options={rmList}
                  {...selectBoxCommonStyle(false)}
                  {...selectFiledCommonFormikFunction('assign_toRm')}
                />
                {loadingRMList ? (
                  <div className="relative text-grey-50 z-10 font-normal text-sm pt-px text-md -ml-16 mt-4 w-2">
                    <CircularProgress
                      style={{ width: '25px', height: '25px' }}
                      className="text-teal"
                    />
                  </div>
                ) : null}
              </div>
            ) : null}

            <div className="w-full mt-8">
              <button
                type="button"
                onClick={handleSubmition}
                className="submitButton text-16 w-56 h-12 font-medium  font-roboto"
                disabled={
                  mobileCheckinhgLoader ||
                  loanProductLoading ||
                  Object.keys(formik.errors).length != 0
                    ? true
                    : false || userType
                    ? loadingRMList
                    : false
                }
              >
                Create lead
              </button>
            </div>
          </div>
        </Modal>
      </div>
      <PopUp type={type} text={text} show={show} setShow={setShow} />
    </form>
  );
};

export default AddLeadsRmSide;
